@if(mode==="edit" || mode==="add"){
<div class="ppl-mt20">
  <form nz-form nz-row [formGroup]="contactForm" class="ppl-p0">
    @if(isAttrAvailable('contactMethod')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactMethod">{{ getAttributes("contactMethod").label }}
          @if(getAttributes('contactMethod').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nzLabelAlign="left" nzTooltipPlacement="topRight">
          <!-- <nz-radio-group
            nz-tooltip
            nzTooltipTitle="{{ getAttributes('contactMethod').tooltip }}"
            nzTooltipPlacement="topRight"
            formControlName="contactMethod"
            class="ppl-radio-group"
            id="contactMethod"
          >
            @for(opt of communicationType; track $index){
            <label nz-radio-button [nzValue]="opt.lkpValueCode">{{
              opt.lkpValueName
            }}</label>
            }
          </nz-radio-group> -->
          <div [ngClass]="{'error': validationErrors['contactMethod'] }">
            <ppl-dropdown-select id="contactMethod" formControlName="contactMethod" [options]="communicationType"
              [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              (selectionChange)="onContactMethodSelection($event)" [disabled]="mode === 'edit'"
              [attr.aria-invalid]="validationErrors['contactMethod'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['contactMethod'] ? 'contactMethod-error' : null"></ppl-dropdown-select>
          </div>
          @if (validationErrors['contactMethod']) {
          <span class="pl-1 error-message">{{validationErrors['contactMethod']}}</span>
          }
        </nz-form-control>
      </nz-row> </nz-form-item>} @if(isAttrAvailable('value')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="value">{{ contactMethodType ?? getAttributes("value").label }}
          @if(getAttributes('value').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control pl-2">
          <input nz-input nz-tooltip
            nzTooltipTitle="{{ contactMethodType ? `Please enter your ${contactMethodType}` : getAttributes('value').tooltip }}"
            nzTooltipPlacement="topRight" formControlName="value" id="value"
            placeholder="{{ contactMethodType ?? getAttributes('value').placeholder }}"
            [ngClass]="{'error': validationErrors['value'] }" (input)="limitDigits($event)" />
          @if (validationErrors['value']) {
          <span class="pl-1 error-message">{{validationErrors['value']}}</span>
          }
          @if (phoneNUmberError) {
          <span class="pl-1 error-message">Please enter a valid 10 digit Phone number</span>
          }
          @if (contactForm.get('contactMethod')?.value === 'mobile') {
          <p class="pl-1 info-message">
            By selecting "Text", I agree that PPL may contact me via text
            message for any purpose including via an automated dialing system. I
            understand that I will be responsible for any charges that may apply
            and that I can opt out or change my communication preferences at any
            time using the PPL platform.</p>
          } @else if (contactForm.get('contactMethod')?.value === 'altPhone') {
          <p class="pl-1 info-message">
            By selecting "Telephone", I agree that PPL may contact me via
            telephone for any purpose including via an automated dialing system
            or prerecorded voice. I understand ​that I will be responsible for
            any charges that may apply and that I can opt out or change my
            communication preferences at any time using the PPL platform.</p>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    } @if(isAttrAvailable('preferred')){
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="preferred" class="ppl-form-label">{{
          getAttributes("preferred").label }}</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <nz-switch class="ppl-switch" nzId="preferred" formControlName="preferred" pplNzAriaLabel
            nzAriaLabel="preferred"></nz-switch>
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
  </form>
</div>
@if(showPreferredDeleteMessageInEdit) {
<div class="w-100 alert alert-warning d-flex justify-content-between align-items-center">
  <span>{{preferredDeleteMessage}}</span>
  <span class="close-icon" (click)="closePreferredDeleteMessage()">×</span>
</div>
}
<div class="custom-row">

  <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="cancelEdit()"></ppl-button>

  <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
    [disabled]="mode === 'edit' && !contactForm.dirty"
    (click)="save()" *authorize="[pageId, tabId, 'CommunicationMethods', 'section', 'edit']"></ppl-button>

</div>
} @else if(mode==="read"){
@if(leadStatus !== approvedStatus && !readOnly && !allContactMethodsUsed) {
<div class="custom-row">
  <ppl-button label="Add" icon="fa fa-plus" [customClass]="'ghost-button'" [iconPosition]="'left'" (click)="add()"
    *authorize="[pageId, tabId, 'CommunicationMethods', 'section', 'edit']"></ppl-button>

  <!-- <span nz-icon nzType="plus-circle" nzTheme="outline" (click)="add()" *authorize="[pageId, tabId, 'CommunicationMethods', 'section', 'edit']"></span> -->
</div>
}

@if(showPreferredDeleteMessageInDelete) {
<div class="w-100 alert alert-warning d-flex justify-content-between align-items-center">
  <span>{{preferredDeleteMessage}}</span>
  <span class="close-icon" (click)="closePreferredDeleteMessage()">×</span>
</div>
}

@if(copyOfGridData.length > 0){
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isSectionEditable || isSectionDeletable" [data]="copyOfGridData"
  [disableSelection]="true" [cols]="cols" (gridAction)="action($event)" [gridTitle]="false" [pagination]="false"
  [loadPage]="true">
</ppl-list-table>
} @else {
<nz-row>
  <p>No Data found</p>
</nz-row>
}



}@else if (mode==="read" && !copyOfGridData) {
<nz-row>
  <p>No Data found</p>
</nz-row>
}